<template>
    <div class="outras-revistas">
        <div class="outras-header">
            <div class="outras-eyebrow">Explorar</div>
            <h2 class="outras-title">Outras publicações</h2>
            <p class="outras-sub">Amplie seu repertório com os demais periódicos da plataforma</p>
        </div>

        <div class="outras-grid" v-if="lstOutrasRevistas.length > 0">
            <div class="outra-card"
                 v-for="item in lstOutrasRevistas"
                 :key="item.idTipoPeriodico">

                <!-- Capa empilhada -->
                <div class="outra-card__cover">
                    <img :src="item.urlImagemRevistas"
                         :alt="item.nmTipoPeriodico + ' — edições'"
                         class="outra-card__stack"
                         @error="onImgError" />

                    <!-- Overlay de lock para sem acesso -->
                    <div class="outra-card__lock" v-if="!item.flAcesso">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
                    </div>
                </div>

                <!-- Logo + info -->
                <div class="outra-card__info">
                    <img :src="item.urlImagemP"
                         :alt="item.nmTipoPeriodico"
                         class="outra-card__logo"
                         @error="onImgError" />

                    <p class="outra-card__name">{{ item.nmTipoPeriodico }}</p>

                    <template v-if="item.flAcesso">
                        <router-link class="outra-card__btn"
                                     :to="{ name: 'ListaPeriodicos', params: { tipo: item.idTipoPeriodico } }">
                            Ver edições
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
                        </router-link>
                    </template>
                    <template v-else>
                        <button class="outra-card__btn outra-card__btn--locked" @click="avisoAcessoRevista">
                            Sem acesso
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
                        </button>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import logoLicicon from '@/assets/img/Periodicos/licicon_metade_pequeno-min.png'
    import logoNp from '@/assets/img/Periodicos/logo_revista_np.png'
    import logoPregoeiro from '@/assets/img/Periodicos/logo_revista_pregoeiro.png'
    import logoGovernanca from '@/assets/img/Periodicos/logo_revista_governanca.png'

    import revistasLicicon from '@/assets/img/Periodicos/revistas_licicon.png'
    import revistasNp from '@/assets/img/Periodicos/revistas_np.png'
    import revistasPregoeiro from '@/assets/img/Periodicos/revistas_pregoeiro.png'
    import revistasGovernanca from '@/assets/img/Periodicos/revistas_governanca.png'

    import { avisoErro } from '@/config/global'

    export default {
        name: 'OutrasRevistas',
        components: {},
        data() {
            return {
                lstOutrasRevistas: [],
            }
        },
        props: {
            lstTipoRevistas: {
                type: Array,
                required: true,
            },
        },
        methods: {
            load() {
                this.lstOutrasRevistas = []
                for (let i = 0; i < this.lstTipoRevistas.length; i++) {
                    const item = { ...this.lstTipoRevistas[i] }

                    if (item.classe === 'licicon') {
                        item.urlImagemP = logoLicicon
                        item.urlImagemRevistas = revistasLicicon
                    } else if (item.classe === 'np') {
                        item.urlImagemP = logoNp
                        item.urlImagemRevistas = revistasNp
                    } else if (item.classe === 'pregoeiro') {
                        item.urlImagemP = logoPregoeiro
                        item.urlImagemRevistas = revistasPregoeiro
                    } else if (item.classe === 'governanca') {
                        item.urlImagemP = logoGovernanca
                        item.urlImagemRevistas = revistasGovernanca
                    }

                    this.lstOutrasRevistas.push(item)
                }
            },

            onImgError(e) {
                e.target.style.opacity = '0'
            },

            avisoAcessoRevista() {
                avisoErro('Você ainda não tem acesso a este produto. Entre em contato com nossa equipe e adquira já!')
            },
        },
        mounted() {
            this.load()
        },
        watch: {
            lstTipoRevistas: {
                handler() { this.load() },
                deep: true,
            },
        },
    }
</script>

<style lang="scss" scoped>
    .outras-revistas {
        --gold: #C8922A;
        --gold-light: #E8A83A;
        --gold-pale: #fdf0d5;
        --dark: #1A1A2E;
        --dark-mid: #2a2a42;
        --muted: #7a7060;
        --border: #DEDBD4;
        --border-gold: rgba(200, 146, 42, 0.3);
        --shadow-sm: 0 2px 8px rgba(26, 26, 46, 0.07);
        --shadow-md: 0 8px 32px rgba(26, 26, 46, 0.1);
        --shadow-lg: 0 20px 60px rgba(26, 26, 46, 0.14);
        --warm-white: #fdfcf9;
        --warm-off: #f5f2eb;
    }

    /* ── CABEÇALHO DA SEÇÃO ── */
    .outras-header {
        margin-bottom: 2rem;
    }

    .outras-eyebrow {
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.14em;
        text-transform: uppercase;
        color: var(--gold);
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        gap: 10px;

        &::before {
            content: '';
            width: 24px;
            height: 2px;
            background: var(--gold);
            display: inline-block;
        }
    }

    .outras-title {
        font-family: 'Playfair Display', serif;
        font-size: 1.5rem;
        font-weight: 700;
        color: var(--dark);
        margin-bottom: 6px;
    }

    .outras-sub {
        font-size: 0.875rem;
        color: var(--muted);
        margin: 0;
    }

    /* ── GRID ── */
    .outras-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 1.25rem;
    }

    /* ── CARD ── */
    .outra-card {
        background: #fff;
        border: 1px solid var(--border);
        border-radius: 12px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        box-shadow: var(--shadow-sm);
        transition: transform 0.3s, border-color 0.3s, box-shadow 0.3s;

        &:hover {
            transform: translateY(-4px);
            border-color: var(--gold);
            box-shadow: var(--shadow-lg), 0 0 0 1px var(--border-gold);
        }
    }

    /* Área da capa empilhada */
    .outra-card__cover {
        position: relative;
        background: var(--warm-off);
        border-bottom: 1px solid var(--border);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2rem 1.5rem;
        min-height: 180px;
        overflow: hidden;
    }

    .outra-card__stack {
        max-width: 100%;
        max-height: 160px;
        object-fit: contain;
        display: block;
        filter: drop-shadow(0 8px 20px rgba(26, 26, 46, 0.18));
        transition: transform 0.3s;
    }

    .outra-card:hover .outra-card__stack {
        transform: translateY(-4px) scale(1.02);
    }

    /* Ícone de cadeado para sem acesso */
    .outra-card__lock {
        position: absolute;
        top: 0.75rem;
        right: 0.75rem;
        width: 32px;
        height: 32px;
        background: rgba(26, 26, 46, 0.65);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgba(255,255,255,0.7);
        backdrop-filter: blur(4px);
    }

    /* Área de info */
    .outra-card__info {
        padding: 1.25rem 1.25rem 1.5rem;
        display: flex;
        flex-direction: column;
        gap: 0.6rem;
        flex: 1;
    }

    /* Logo pequena */
    .outra-card__logo {
        max-height: 28px;
        max-width: 160px;
        object-fit: contain;
        object-position: left center;
        filter: brightness(0);
    }

    .outra-card__name {
        font-family: 'Playfair Display', serif;
        font-size: 0.95rem;
        font-weight: 700;
        color: var(--dark);
        margin: 0;
        line-height: 1.3;
    }

    /* Botão CTA */
    .outra-card__btn {
        margin-top: auto;
        display: inline-flex;
        align-items: center;
        gap: 0.4rem;
        font-family: 'DM Sans', sans-serif;
        font-size: 0.72rem;
        font-weight: 700;
        letter-spacing: 0.09em;
        text-transform: uppercase;
        color: var(--gold);
        text-decoration: none;
        background: none;
        border: 1px solid var(--border-gold);
        border-radius: 5px;
        padding: 0.5rem 0.9rem;
        cursor: pointer;
        transition: all 0.2s;
        align-self: flex-start;

        svg {
            transition: transform 0.2s;
        }

        &:hover {
            background: var(--gold);
            border-color: var(--gold);
            color: #fff;

            svg {
                transform: translateX(3px);
            }
        }

        &--locked {
            color: var(--muted);
            border-color: var(--border);
            cursor: not-allowed;

            &:hover {
                background: var(--muted);
                border-color: var(--muted);
                color: #fff;

                svg {
                    transform: none;
                }
            }
        }
    }

    /* ── RESPONSIVE ── */
    @media (max-width: 992px) {
        .outras-grid {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @media (max-width: 575px) {
        .outras-grid {
            grid-template-columns: 1fr;
        }

        .outras-title {
            font-size: 1.25rem;
        }
    }
</style>